import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import { E0円非表示フラグ, E有無フラグ } from '@/openapi/enum';
import { Eフリーキャッシュフロー種別, 計画書データ表示設定Request } from '@/openapi/user';

import 計画書データ表示設定Mixin from '@/entries/user/mixins/計画書データ表示設定Mixin';

type 表示設定Key = keyof Pick<
  計画書データ表示設定Request,
  | 'c過去データ表示フラグ'
  | 'c第1期月次作成フラグ'
  | 'c分析0円非表示フラグ'
  | 'c計画0円非表示フラグ'
  | 'cモニタリング0円非表示フラグ'
  | 'cフリーキャッシュフロー種別'
>;

export default mixins(計画書データ表示設定Mixin).extend({
  name: 'C計画書データ表示設定CheckBox',

  props: {
    requestKey: {
      type: String as PropType<表示設定Key>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    is返済計画: {
      type: Boolean,
      default: false,
    },
  },

  data(): {
    isChecked: boolean;
  } {
    return {
      isChecked: false,
    };
  },

  computed: {
    label(): string {
      switch (this.requestKey) {
        case 'c過去データ表示フラグ':
          return '前期以前の過去データを表示する';

        case 'c第1期月次作成フラグ':
          return '計画第1期を月次計画で作成する';

        case 'cフリーキャッシュフロー種別':
          return `キャッシュフロー計算書のFCFを基に${this.is返済計画 ? '返済計画' : '債務償還年数'}を計算する`;

        default:
          return '数値が0の行は非表示にする';
      }
    },
  },

  created(): void {
    switch (this.requestKey) {
      case 'c過去データ表示フラグ':
      case 'c第1期月次作成フラグ':
        this.isChecked = this.計画書[this.requestKey] === E有無フラグ.あり;
        break;

      case 'cフリーキャッシュフロー種別':
        this.isChecked = this.計画書[this.requestKey] === Eフリーキャッシュフロー種別.CF計算書;
        break;

      default:
        this.isChecked = this.計画書[this.requestKey] === E0円非表示フラグ.非表示;
        break;
    }
  },

  methods: {
    async onChangeChecked(): Promise<void> {
      await this.save計画書データ表示設定({ [this.requestKey]: this.$_getCheckedValue() });
      this.$emit('change');
    },
    $_getCheckedValue(): E有無フラグ | Eフリーキャッシュフロー種別 | E0円非表示フラグ {
      switch (this.requestKey) {
        case 'c過去データ表示フラグ':
        case 'c第1期月次作成フラグ':
          return this.isChecked ? E有無フラグ.あり : E有無フラグ.なし;

        case 'cフリーキャッシュフロー種別':
          return this.isChecked ? Eフリーキャッシュフロー種別.CF計算書 : Eフリーキャッシュフロー種別.通常;

        default:
          return this.isChecked ? E0円非表示フラグ.非表示 : E0円非表示フラグ.表示;
      }
    },
  },
});
